var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShirtBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.16 8.002c-.565 0-1.024.46-1.024 1.025v13.867H6.672V9.027c0-.565-.46-1.025-1.024-1.025-.565 0-1.025.46-1.025 1.025v.97L2.926 8.278l4.16-3.724 2.42-.874a4.147 4.147 0 0 0 4.692 2.678 4.118 4.118 0 0 0 3.113-2.677l2.42.873 4.147 3.724-1.693 1.714v-.965c0-.565-.46-1.025-1.025-1.025m4.97-.497-.026-.025-5.155-4.583a1.019 1.019 0 0 0-.342-.205l-3.72-1.33a1.028 1.028 0 0 0-1.374.928c-.004.084-.103 2.07-2.098 2.101-1.97-.03-2.12-1.903-2.13-2.119a1.025 1.025 0 0 0-1.023-.971l-.06.002a1.025 1.025 0 0 0-.285.058L6.194 2.708a1.016 1.016 0 0 0-.33.2L.738 7.478a1.019 1.019 0 0 0-.319.717c-.007.275.093.534.308.758l3.915 3.958v11.031c0 .565.46 1.025 1.024 1.025h15.508c.565 0 1.025-.46 1.025-1.025V12.911l3.903-3.946c.41-.39.427-1.04.027-1.46",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShirtBlack);
export default __webpack_public_path__ + "static/media/icon_shirt_black.a1d51e69a3551f71b6ebf0df42905809.svg";
export { ForwardRef as ReactComponent };